import { useEffect, useState } from "react";
import { useFormContext } from "../contexts/FormContext";

// Map of form types to their respective form IDs
const FORM_ID_MAP = {
    faleConosco: "fale-conosco-c628f82c97defc9b9dcd",
    projects: "projects-82d00ec0e0199f370c7b",
    innovation: "innovation-a6ce2274a5bf0ab96917",
    solutions: "solutions-e7a0e908c8d7df1365dd"
};

// Get token from environment variable
const RD_TOKEN = process.env.RD_TOKEN || "null";

export default function FormularioRD({ 
    formType: propFormType,
    formId: propFormId, 
    token = RD_TOKEN,
    width = "auto"
}) {
    const { formType: contextFormType } = useFormContext();
    const [isLoading, setIsLoading] = useState(true);
    const [formKey, setFormKey] = useState(Date.now()); // Unique key for re-rendering
    
    // Use prop formType if provided, otherwise use context formType
    const formType = propFormType || contextFormType || "faleConosco";
    
    // Determine form ID based on formType or use provided formId
    const formId = propFormId || FORM_ID_MAP[formType] || FORM_ID_MAP.faleConosco;

    // Function to create the form
    const createForm = () => {
        setIsLoading(true);
        
        // Generate a new form key to force re-render
        setFormKey(Date.now());
        
        // Small delay to ensure DOM is ready
        setTimeout(() => {
            try {
                // Check if script already exists
                const existingScript = document.querySelector('script[src="https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js"]');
                
                const initializeForm = () => {
                    try {
                        // Clean up any existing form with the same ID
                        if (window.RDStationForms && window.RDStationForms.destroy) {
                            try {
                                window.RDStationForms.destroy(formId);
                            } catch (e) {
                                console.log('No previous form to destroy');
                            }
                        }
                        
                        // Create new form
                        new window.RDStationForms(formId, token).createForm();
                        setTimeout(() => setIsLoading(false), 800);
                    } catch (error) {
                        console.error("Error creating RD Station form:", error);
                        setIsLoading(false);
                    }
                };
                
                if (existingScript) {
                    // If script exists, check if RDStationForms is available
                    if (window.RDStationForms) {
                        initializeForm();
                    } else {
                        // If RDStationForms is not available yet, wait for it
                        const checkRDStationForms = setInterval(() => {
                            if (window.RDStationForms) {
                                clearInterval(checkRDStationForms);
                                initializeForm();
                            }
                        }, 100);
                        
                        // Clear interval after 5 seconds to prevent infinite checking
                        setTimeout(() => {
                            clearInterval(checkRDStationForms);
                            setIsLoading(false);
                        }, 5000);
                    }
                } else {
                    // If script doesn't exist, create and append it
                    const script = document.createElement("script");
                    script.src = "https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js";
                    script.async = true;
                    
                    script.onload = () => initializeForm();
                    
                    script.onerror = () => {
                        console.error("Failed to load RD Station forms script");
                        setIsLoading(false);
                    };
                    
                    document.body.appendChild(script);
                }
            } catch (error) {
                console.error("Error in form creation process:", error);
                setIsLoading(false);
            }
        }, 100);
    };
    
    // Initialize form on component mount
    useEffect(() => {
        createForm();
        
        return () => {
            // Cleanup when component unmounts
            try {
                if (window.RDStationForms && window.RDStationForms.destroy) {
                    window.RDStationForms.destroy(formId);
                }
            } catch (error) {
                console.error("Error destroying RD Station form:", error);
            }
        };
    }, [formId, token]);

    return (
        <div style={{ width: width }} key={formKey}>
            {isLoading && (
                <div className="flex justify-center items-center py-10">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#A002CB]"></div>
                </div>
            )}
            <div
                id={formId}
                className={isLoading ? 'hidden' : 'block'}
            ></div>
        </div>
    );
}
